import { faFilterList } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, Dropdown, Form, Input, InputNumber, Menu, Select } from "antd";
import { useEffect, useState } from "react";
import CustomButton from "../common/CustomButton";
import DocumentService from "../services/Document/DocumentService";
import OrgService from "../services/Org/OrgService";

const FilterDropdown = ({ onApplyFilters, type, size, roles }) => {
  const [form] = Form.useForm();
  const [supplier, setSupplier] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleSubmit = (values) => {
    onApplyFilters(values);
    setDropdownVisible(false);
  };

  const clearForm = () => {
    form.resetFields();
    onApplyFilters({});
    setDropdownVisible(false);
  };

  const checkFormValues = () => {
    const values = form.getFieldsValue();
    onApplyFilters(values);
  };

  useEffect(() => {
    if (type === "purchaseorder") {
      fetchSupplier();
    }
    if (type === "documentmanager") {
      fetchDocumentTypes();
    }
  }, [type]);

  const fetchSupplier = async (searchText = "") => {
    try {
      const response = await OrgService.getSupplierDropDown(searchText);
      setSupplier(response.data);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
  };

  const fetchDocumentTypes = async () => {
    try {
      const response = await DocumentService.getAllDocumentTypes();
      setDocumentTypes(response.data);
    } catch (error) {
      console.error("Error fetching document types:", error);
    }
  };


  const renderFormFields = () => {
    switch (type) {
      case "user-page":
        return (
          <>
            <Form.Item name="firstName" label="First Name">
              <Input
                allowClear
                type="text"
                placeholder="Enter first name"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="lastName" label="Last Name">
              <Input
                allowClear
                type="text"
                placeholder="Enter last name"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="email" label="Email">
              <Input
                allowClear
                type="text"
                placeholder="Enter email"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="roles" label="Roles">
              <Select
                mode="multiple"
                placeholder="Select roles"
                size="middle"
                onClear={() => {
                  form.setFieldsValue({ roles: [] });
                  checkFormValues();
                }}
                className="text-sm py-2"
                allowClear
              >
                {roles?.map((role) => (
                  <Select.Option key={role.id} value={role.id}>
                    {role.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="isActive" valuePropName="checked">
              <Checkbox size="middle" className="text-sm">
                Active Users
              </Checkbox>
            </Form.Item>
          </>
        );
      case "supplier":
        return (
          <>
            <Form.Item name="name" label="Name">
              <Input
                allowClear
                type="text"
                placeholder="Enter supplier name"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="email" label="Email">
              <Input
                allowClear
                type="text"
                placeholder="Enter supplier email"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="phoneNumber" label="Phone Number">
              <Input
                allowClear
                type="number"
                placeholder="Enter supplier phone number"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="isActive" valuePropName="checked">
              <Checkbox className="text-sm">Active Suppliers</Checkbox>
            </Form.Item>
          </>
        );
      case "stock-page":
        return (
          <>
            <Form.Item
              name="sku"
              label="SKU"
              rules={[{ message: "Please enter SKU" }]}
            >
              <Input
                type="text"
                placeholder="Enter SKU"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
              rules={[{ message: "Please enter description" }]}
            >
              <Input
                type="text"
                placeholder="Enter description"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item
              name="qoh"
              label="QOH"
              rules={[{ message: "Please enter QOH" }]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter QOH"
                precision={4}
                onPressEnter={checkFormValues}
                className="text-sm py-[2px] !h-8 w-full"
              />
            </Form.Item>
            <Form.Item
              name="palletQty"
              label="Pallet Qty"
              rules={[{ message: "Please enter pallet qty" }]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter pallet qty"
                className="text-sm py-[2px] !h-8 w-full"
                onPressEnter={checkFormValues}
              />
            </Form.Item>
            <Form.Item
              name="packSize"
              label="Pack Size"
              rules={[{ message: "Please enter pack size" }]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter pack size"
                className="text-sm py-[2px] !h-8 w-full"
                onPressEnter={checkFormValues}
              />
            </Form.Item>
            <Form.Item
              name="dimensionHeightCM"
              label="Dimension Height(cm)"
              rules={[
                {
                  message: "Please enter height(cm)",
                },
              ]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter height(cm)"
                precision={4}
                className="text-sm py-[2px] !h-8 w-full"
                onPressEnter={checkFormValues}
              />
            </Form.Item>
            <Form.Item
              name="dimensionWidthCm"
              label="Dimension Width(cm)"
              rules={[
                {
                  message: "Please enter width(cm)",
                },
              ]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter width(cm)"
                precision={4}
                className="text-sm py-[2px] !h-8 w-full"
                onPressEnter={checkFormValues}
              />
            </Form.Item>
            <Form.Item
              name="dimensionLengthCm"
              label="Dimension Length(cm)"
              rules={[
                {
                  message: "Please enter length(cm)",
                },
              ]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter length(cm)"
                precision={4}
                className="text-sm py-[2px] !h-8 w-full"
                onPressEnter={checkFormValues}
              />
            </Form.Item>
            <Form.Item
              name="dimensionWeightKg"
              label="Dimension Weight(kg)"
              labelAlign="left"
              rules={[
                {
                  message: "Please enter weight(kg)",
                },
              ]}
            >
              <InputNumber
                controls={false}
                placeholder="Enter weight(kg)"
                precision={4}
                className="text-sm py-[2px] !h-8 w-full"
                onPressEnter={checkFormValues}
              />
            </Form.Item>
          </>
        );
      case "tracking-dashboard":
        return (
          <>
            <Form.Item name="userReference" label="User Reference">
              <Input
                type="text"
                placeholder="Enter User reference"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="imo" label="IMO">
              <Input
                type="text"
                placeholder="Enter IMO"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="number" label="Container No.">
              <Input
                type="text"
                placeholder="Enter container no."
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="vesselName" label="Vessel Name">
              <Input
                type="text"
                placeholder="Enter vessel name"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="status" label="Status">
              <Input
                type="text"
                placeholder="Enter status "
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
          </>
        );
      case "purchaseorder":
        return (
          <>
            <Form.Item name="purchaseOrderNum" label="Purchase Order Num">
              <Input
                allowClear
                type="text"
                placeholder="Enter purchase order number"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="priority" label="Priority">
              <Select
                placeholder="Select Priority"
                size="middle"
                onClear={() => {
                  form.setFieldsValue({ priority: [] });
                  checkFormValues();
                }}
                className="text-sm py-2 !h-8"
                allowClear
              >
                {[
                  { id: "1", name: "Very High" },
                  { id: "2", name: "High" },
                  { id: "3", name: "Medium" },
                  { id: "4", name: "Low" },
                  { id: "5", name: "Lowest" },
                ].map((priority) => (
                  <Select.Option key={priority.id} value={priority.id}>
                    {priority.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="supplierID" label="Supplier">
              <Select
                showSearch
                placeholder="Select suppliers"
                size="middle"
                onSearch={fetchSupplier}
                onClear={() => {
                  form.setFieldsValue({ supplierID: null });
                  checkFormValues();
                }}
                filterOption={false}
                className="text-sm py-2"
                allowClear
              >
                {supplier.map((supplier) => (
                  <Select.Option key={supplier.id} value={supplier.id}>
                    {supplier.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </>
        );
      case "documentmanager":
        return (
          <>
            <Form.Item name="supplier" label="Supplier">
              <Input
                allowClear
                type="text"
                placeholder="Enter Supplier name"
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="containerNumber" label="Container No.">
              <Input
                type="text"
                placeholder="Enter Container no."
                size="middle"
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                allowClear
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item
              name="purchaseOrder"
              label="Purchase Order Number"
              tooltip="Enter either full 6-digit PO or last 4 digits. I'll auto-format it."
              rules={[
                {
                  validator: (_, value) => {
                    const regex6 = /^\d{6}$/;
                    const regex4 = /^\d{4}$/;
                    if (!value || regex6.test(value) || regex4.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Enter either 6 digits or last 4 digits'));
                  }
                }
              ]}
            >
              <Input
                allowClear
                type="text"
                placeholder="Enter PO number"
                size="middle"
                onBlur={(e) => {
                  const val = e.target.value;
                  if (/^\d{4}$/.test(val)) {
                    const padded = val.padStart(6, '0');
                    form.setFieldsValue({ purchaseOrder: padded });
                  }
                }}
                onPressEnter={checkFormValues}
                onClear={checkFormValues}
                className="text-sm py-2 !h-8"
              />
            </Form.Item>
            <Form.Item name="documentType" label="Document Type">
              <Select
                mode="multiple"
                placeholder="Select Document Types"
                size="middle"
                onClear={() => {
                  form.setFieldsValue({ documentTypes: [] });
                  checkFormValues();
                }}
                className="text-sm py-2"
                allowClear
              >
                {documentTypes.map((documentType) => (
                  <Select.Option key={documentType.id} value={documentType.id}>
                    {documentType.type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </>
        );
      default:
        return null;
    }
  };

  const filterMenu = (
    <Menu className="p-2 bg-white rounded-lg shadow-md">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="space-y-4 mx-3"
      >
        {renderFormFields()}
        <Form.Item>
          <div className="flex justify-between mb-4">
            <CustomButton
              size="small"
              onClick={clearForm}
              className="px-3 py-1 text-sm"
            >
              Reset Filters
            </CustomButton>
            <CustomButton
              className="ml-4 px-3 py-1 text-sm"
              size="small"
              type="primary"
              htmlType="submit"
            >
              Apply Filters
            </CustomButton>
          </div>
        </Form.Item>
      </Form>
    </Menu>
  );

  return (
    <Dropdown
      overlay={filterMenu}
      trigger={["click"]}
      visible={dropdownVisible}
      onVisibleChange={(visible) => setDropdownVisible(visible)}
    >
      <CustomButton className="flex items-center rounded-lg" size={size}>
        <FontAwesomeIcon icon={faFilterList} />
        Filters
      </CustomButton>
    </Dropdown>
  );
};

export default FilterDropdown;
